
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { UserService } from '../_service/user.service';
import { AlertifyService } from '../_service/alertify.service';
import { GenerateComponent } from './generate/generate.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ReportService } from '../_service/report.service';
import { TreeComponent } from '../tree/tree.component';
import { AuthService } from '../_service/auth.service';
import { ProductinfoComponent } from './reportcomponents/productinfo/productinfo/productinfo.component';
import { ManufacturerinfoComponent } from './reportcomponents/manufacturer/manufacturerinfo/manufacturerinfo.component';
import { HealthhazardComponent } from './reportcomponents/healthhazard/healthhazard/healthhazard.component';
import { PhysicalhazardComponent } from './reportcomponents/physicalhazard/physicalhazard.component';
import { ProductchemicalComponent } from './reportcomponents/productchemical/productchemical/productchemical.component';

@Component({
  selector: "report",
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  @ViewChild(ProductinfoComponent, {static: true}) productInformation: ProductinfoComponent;
  @ViewChild(ManufacturerinfoComponent, {static: true}) manufacturerInformation: ManufacturerinfoComponent;
  @ViewChild(HealthhazardComponent, {static: true}) healthInformation: HealthhazardComponent;
  @ViewChild(PhysicalhazardComponent, {static: true}) physicalHazardInformation: PhysicalhazardComponent;
  @ViewChild(ProductchemicalComponent, {static: true}) productChemicalInformation: ProductchemicalComponent;
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  selectedLocations: any = ([] = []);
  tooltip = 'In an excel generated report, you might add filters to the desired columns.';
  public rbselection: string;

  checkAllSuppliers = false;
  checkInventoryStatus = false;
  checkWorkSheetUpdate = false;
  checkProductPropertyInfo = false;
  checkOneProductPerRow = true;

  physicalHazardInfo: any = {};
  healthHazardInfo: any = {};
  productChemicalInfo: any = {};
  productInfo: any = {};
  manufacturerInfo: any = {};

  mostRecentRequestDate;
  mostRecentRequestDateChecked = false;

  oneProductPR: any;
  oneRowPL: any;
  ProductPropertyInfo: any;

  locationsNotSelectedError: any = {};
  selectionRequiredError: any = {};


  isLoading = false;

  loading = false;
   // Inventory Info section
   recentRequest;

   model: any = {};

   arrayAuth: number;
   topauths = new FormControl();

   authorities;

   authorityLocation: any = [] = [];
   authorityLocationChecked = false;
 
   selection;
   ProductName;
   report;
   selectedBox;
   selectedAuth: number;
 
   sdsUserId: any;
   sdsUserIdNumber: number;

  locationList = new FormControl('', [Validators.required]);
  locations;
  locationArray;
  selected: number;
  myList: any = [];

  generateModel: any = {};

  passedValue: any;

  changeEvent = (value) => {};

  ngAfterViewInit() {
    this.changeDet.detectChanges();
    this.locationTree.checklistSelection.selected;
  }

  onProductNameChecked() {
    this.productInfo.productName = '';
    if (this.productInfo.productNameChecked) {
      this.passedValue = this.productInfo.productNameChecked;
      this.productInfo.productName = 'ProductName';
    }
  }

  onManufacturerNameChecked() {
    this.productInfo.manufacturerName = '';
    if (this.productInfo.manufacturerNameChecked) {
      this.productInfo.manufacturerName = 'ManufacturerName';
    }
  }

  onSelectUpdatingWorkSheetClick(event) {
    if (event.value === '1' && event.source._checked) {
      this.productInformation.productNameChecked = true;
      if (this.productInformation.productNameChecked) {
        this.productInformation.onProductNameChecked();
      }
       this.productInformation.manufacturerNameChecked = true;
      if (this.productInformation.manufacturerNameChecked) {
        this.productInformation.onManufacturerNameChecked();
      }
       this.productInformation.sdsFileChecked = true;
      if (this.productInformation.sdsFileChecked) {
        this.productInformation.onSdsFileChecked();
      }
       this.productInformation.sdsURLChecked = true;
      if (this.productInformation.sdsURLChecked) {
        this.productInformation.onSDSURLChecked();
      }
       this.productInformation.revisionDateChecked = true;
      if (this.productInformation.revisionDateChecked) {
        this.productInformation.onRevisionDateChecked();
      }
       this.productInformation.productCodeChecked = true;
      if (this.productInformation.productCodeChecked) {
        this.productInformation.onProductCodeChecked();
      }
      this.productInformation.discontinuedChecked = true;
      if (this.productInformation.discontinuedChecked) {
        this.productInformation.onDiscontinuedChecked();
      }
       this.productInformation.exemptWHMISChecked = true;
      if (this.productInformation.exemptWHMISChecked) {
        this.productInformation.onWHMISExemptChecked();
      }
      this.productInformation.additionalSupplierChecked = true;
      if (this.productInformation.additionalSupplierChecked) {
        this.productInformation.onAdditionalSuppliersChecked();
      }

      this.manufacturerInformation.urlChecked = true;
      if (this.manufacturerInformation.urlChecked) {
        this.manufacturerInformation.onUrlChecked();
      }
      this.manufacturerInformation.sdsURLChecked = true;
      if (this.manufacturerInformation.sdsURLChecked) {
        this.manufacturerInformation.onSDSURLChecked();
      }
      this.manufacturerInformation.contactLocationChecked = true;
      if (this.manufacturerInformation.contactLocationChecked) {
        this.manufacturerInformation.onContactLocationChecked();
      }
      this.manufacturerInformation.effectiveContactMethodChecked = true;
      if (this.manufacturerInformation.effectiveContactMethodChecked) {
        this.manufacturerInformation.onEffectiveContactMethodChecked();
      }
      this.manufacturerInformation.contactDetailsChecked = true;
      if (this.manufacturerInformation.contactDetailsChecked) {
        this.manufacturerInformation.onContactDetailsChecked();
      }
      // this.changeRadioButtons(event.value);
      // this.oneProductPR = 'true';
      // this.checkOneProductPerRow = true;

      this.oneProductPR = 'true';
      this.checkOneProductPerRow = true;
      this.oneRowPL = '';
      this.checkProductPropertyInfo = false;
      this.productChemicalInformation.checkAllProdChemical = false;
      this.manufacturerInformation.checkAllManufacturerInfo = true;
      this.healthInformation.checkAllHealthHazard = false;
      this.physicalHazardInformation.checkAllPhysicalHazard = false;
      this.locationTree.checklistSelection.clear();
      this.productInformation.dateAddedDisabled = true; // disable date
      this.productInformation.dateAddedChecked = false; // uncheck date

      this.physicalHazardInformation.physicalStateChecked = false;
      this.physicalHazardInformation.combustibleDustsChecked = false;
      this.physicalHazardInformation.flammableAerosolsChecked = false;
      this.physicalHazardInformation.flammableGasesChecked = false;
      this.physicalHazardInformation.flammableLiquidsChecked = false;
      this.physicalHazardInformation.flammableSolidsChecked = false;
      this.physicalHazardInformation.gasesUnderPressureChecked = false;
      this.physicalHazardInformation.oxidizingGasesChecked = false;
      this.physicalHazardInformation.oxidizingLiquidsChecked = false;
      this.physicalHazardInformation.oxidizingSolidsChecked = false;
      this.physicalHazardInformation.organicPeroxidesChecked = false;
      this.physicalHazardInformation.pyrophoricGasesChecked = false;
      this.physicalHazardInformation.pyrophoricLiquidsChecked = false;
      this.physicalHazardInformation.pyrophoricSolidsChecked = false;
      this.physicalHazardInformation.selfHeatingSubstancesMixturesChecked = false;
      this.physicalHazardInformation.simpleAsphyxiantsChecked = false;
      this.physicalHazardInformation.substancesMixturesWaterGasChecked = false;

      this.healthInformation.acuteToxicityChecked = false;
      this.healthInformation.acuteToxicityRouteChecked = false;
      this.healthInformation.aspirationHazardChecked = false;
      this.healthInformation.bioHazardInfectiousMatChecked = false;
      this.healthInformation.carcinogenicityChecked = false;
      this.healthInformation.germCellMutagenicityChecked = false;
      this.healthInformation.reproductiveToxicityChecked = false;
      this.healthInformation.respiratorySkinSenChecked = false;
      this.healthInformation.seriousEyeDamageChecked = false;
      this.healthInformation.skinCorrosionIrritationChecked = false;
      this.healthInformation.skinCorrosionIrritationRouteChecked = false;
      this.healthInformation.specificTargetOriginToxChecked = false;
      this.healthInformation.specificTargetOrgExposureChecked = false;
      this.healthInformation.healthHazardsnotClassChecked = false;

      this.productChemicalInformation.hmisRatingsChecked = false;
      this.productChemicalInformation.iarcMonographChecked = false;
      this.productChemicalInformation.transportHazardClassChecked = false;
      this.productChemicalInformation.nfpaRatingsChecked = false;
      this.productChemicalInformation.ACGIHCarcinogenicityNotationChecked = false;
    } else {
      this.productInformation.revisionDateChecked = false;
      this.productInformation.discontinuedChecked = false;
      this.productInformation.exemptWHMISChecked = false;
    }
  }

  onSelectInventoryStatusReportClick(event) {
    if (event.value === '2' && event.source._checked) {
      this.productInformation.productNameChecked = true;
      if (this.productInformation.productNameChecked) {
        this.productInformation.onProductNameChecked();
      }
        this.productInformation.sdsURLChecked = true;
      if (this.productInformation.sdsURLChecked) {
        this.productInformation.onSDSURLChecked();
      }
        this.productInformation.revisionDateChecked = true;
      if (this.productInformation.revisionDateChecked) {
        this.productInformation.onRevisionDateChecked();
      }
        this.productInformation.discontinuedChecked = true;
      if (this.productInformation.discontinuedChecked) {
        this.productInformation.onDiscontinuedChecked();
      }
        this.productInformation.exemptWHMISChecked = true;
      if (this.productInformation.exemptWHMISChecked) {
        this.productInformation.onWHMISExemptChecked();
      }
      this.productInformation.dateAddedChecked = true;
      if (this.productInformation.dateAddedChecked) {
        this.productInformation.onDateAddedChecked();
      }

      // uncheck on product per row
      this.oneProductPR = '';
      this.checkOneProductPerRow = false;

      this.oneRowPL = 'true';
      this.checkProductPropertyInfo = true;
      this.ProductPropertyInfo = 'true';
      this.locationTree.checkAll();
      this.productChemicalInformation.checkAllProdChemical = false;
      this.physicalHazardInformation.checkAllPhysicalHazard = false;
      this.manufacturerInformation.checkAllManufacturerInfo = false;
      this.healthInformation.checkAllHealthHazard = false;
      this.productInformation.dateAddedChecked = true;
      this.productInformation.dateAddedDisabled = false; // disable date

      this.manufacturerInformation.urlChecked = false;
      this.manufacturerInformation.sdsURLChecked = false;
      this.manufacturerInformation.contactLocationChecked = false;
      this.manufacturerInformation.contactDetailsChecked = false;
      this.manufacturerInformation.effectiveContactMethodChecked = false;

      this.productInformation.manufacturerNameChecked = false;
      this.productInformation.productAliasChecked = false;
      this.productInformation.productCodeChecked = false;
      this.productInformation.registrationNumberChecked = false;
      this.productInformation.sdsFileChecked = false;
      this.productInformation.sdsFormatChecked = false;
      this.productInformation.sdsOriginChecked = false;
      this.productInformation.additionalSupplierChecked = false;
      this.productInformation.lastVerifiedDateChecked = false;
      this.productInformation.exemptionClassChecked = false;

      this.physicalHazardInformation.physicalStateChecked = false;
      this.physicalHazardInformation.combustibleDustsChecked = false;
      this.physicalHazardInformation.flammableAerosolsChecked = false;
      this.physicalHazardInformation.flammableGasesChecked = false;
      this.physicalHazardInformation.flammableLiquidsChecked = false;
      this.physicalHazardInformation.flammableSolidsChecked = false;
      this.physicalHazardInformation.gasesUnderPressureChecked = false;
      this.physicalHazardInformation.oxidizingGasesChecked = false;
      this.physicalHazardInformation.oxidizingLiquidsChecked = false;
      this.physicalHazardInformation.oxidizingSolidsChecked = false;
      this.physicalHazardInformation.organicPeroxidesChecked = false;
      this.physicalHazardInformation.pyrophoricGasesChecked = false;
      this.physicalHazardInformation.pyrophoricLiquidsChecked = false;
      this.physicalHazardInformation.pyrophoricSolidsChecked = false;
      this.physicalHazardInformation.selfHeatingSubstancesMixturesChecked = false;
      this.physicalHazardInformation.simpleAsphyxiantsChecked = false;
      this.physicalHazardInformation.substancesMixturesWaterGasChecked = false;

      this.healthInformation.acuteToxicityChecked = false;
      this.healthInformation.acuteToxicityRouteChecked = false;
      this.healthInformation.aspirationHazardChecked = false;
      this.healthInformation.bioHazardInfectiousMatChecked = false;
      this.healthInformation.carcinogenicityChecked = false;
      this.healthInformation.germCellMutagenicityChecked = false;
      this.healthInformation.reproductiveToxicityChecked = false;
      this.healthInformation.respiratorySkinSenChecked = false;
      this.healthInformation.seriousEyeDamageChecked = false;
      this.healthInformation.skinCorrosionIrritationChecked = false;
      this.healthInformation.skinCorrosionIrritationRouteChecked = false;
      this.healthInformation.specificTargetOriginToxChecked = false;
      this.healthInformation.specificTargetOrgExposureChecked = false;
      this.healthInformation.healthHazardsnotClassChecked = false;

      this.productChemicalInformation.hmisRatingsChecked = false;
      this.productChemicalInformation.iarcMonographChecked = false;
      this.productChemicalInformation.transportHazardClassChecked = false;
      this.productChemicalInformation.nfpaRatingsChecked = false;
      this.productChemicalInformation.ACGIHCarcinogenicityNotationChecked = false;
    } else {
      this.productInformation.revisionDateChecked = false;
      this.productInformation.discontinuedChecked = false;
      this.productInformation.exemptWHMISChecked = false;
    }
  }

  onSelectProductPropertyInfoClick(event) {
    if (event.value === '3' && event.source._checked) {
       this.productInformation.productNameChecked = true;
      if (this.productInformation.productNameChecked) {
        this.productInformation.onProductNameChecked();
      }
      this.productInformation.sdsURLChecked = true;
      if (this.productInformation.sdsURLChecked) {
        this.productInformation.onSDSURLChecked();
      }
      this.productInformation.manufacturerNameChecked = true;
      if (this.productInformation.manufacturerNameChecked) {
        this.productInformation.onManufacturerNameChecked();
      }
      this.productInformation.revisionDateChecked = true;
      if (this.productInformation.revisionDateChecked) {
        this.productInformation.onRevisionDateChecked();
      }
      this.productInformation.lastVerifiedDateChecked = true;
      if (this.productInformation.lastVerifiedDateChecked) {
        this.productInformation.onLastVerifiedDateChecked();
      }
       this.productInformation.discontinuedChecked = true;
      if (this.productInformation.discontinuedChecked) {
        this.productInformation.onDiscontinuedChecked();
      }
       this.productInformation.exemptWHMISChecked = true;
      if (this.productInformation.exemptWHMISChecked) {
        this.productInformation.onWHMISExemptChecked();
      }
      this.productInformation.exemptionClassChecked = true;
      if (this.productInformation.exemptionClassChecked) {
        this.productInformation.onExemptionClassChecked();
      }

      this.healthInformation.acuteToxicityChecked = true;
      if (this.healthInformation.acuteToxicityChecked) {
        this.healthInformation.onAcuteToxicityChecked();
      }
      this.healthInformation.acuteToxicityRouteChecked = true;
      if (this.healthInformation.acuteToxicityRouteChecked) {
        this.healthInformation.onAcuteToxicityRouteChecked();
      }
      this.healthInformation.skinCorrosionIrritationRouteChecked = true;
      if (this.healthInformation.skinCorrosionIrritationRouteChecked) {
        this.healthInformation.onSkinCorrosionIrritationRouteChecked();
      }
      this.healthInformation.aspirationHazardChecked = true;
      if (this.healthInformation.aspirationHazardChecked) {
        this.healthInformation.onAspirationHazardChecked();
      }
      this.healthInformation.bioHazardInfectiousMatChecked = true;
      if (this.healthInformation.bioHazardInfectiousMatChecked) {
        this.healthInformation.onBiohazardousInfectiousMatChecked();
      }
      this.healthInformation.carcinogenicityChecked = true;
      if (this.healthInformation.carcinogenicityChecked) {
        this.healthInformation.onCarcinogenicityChecked();
      }
      this.healthInformation.germCellMutagenicityChecked = true;
      if (this.healthInformation.germCellMutagenicityChecked) {
        this.healthInformation.onGermCellMutagenicityChecked();
      }
      this.healthInformation.reproductiveToxicityChecked = true;
      if (this.healthInformation.reproductiveToxicityChecked) {
        this.healthInformation.onReproductiveToxicityChecked();
      }
      this.healthInformation.respiratorySkinSenChecked = true;
      if (this.healthInformation.respiratorySkinSenChecked) {
        this.healthInformation.onRespiratorySkinSenChecked();
      }
      this.healthInformation.seriousEyeDamageChecked = true;
      if (this.healthInformation.seriousEyeDamageChecked) {
        this.healthInformation.onSeriousEyeDamageIrrChecked();
      }
      this.healthInformation.skinCorrosionIrritationChecked = true;
      if (this.healthInformation.skinCorrosionIrritationChecked) {
        this.healthInformation.onSkinCorrosionIrrChecked();
      }
      this.healthInformation.specificTargetOriginToxChecked = true;
      if (this.healthInformation.specificTargetOriginToxChecked) {
        this.healthInformation.onSpecificTargetOriginToxSingleExpoChecked();
      }
      this.healthInformation.specificTargetOrgExposureChecked = true;
      if (this.healthInformation.specificTargetOrgExposureChecked) {
        this.healthInformation.onSpecificTargetOriginToxRepeatedExpoChecked();
      }
      this.healthInformation.healthHazardsnotClassChecked = true;
      if (this.healthInformation.healthHazardsnotClassChecked) {
        this.healthInformation.onHealthHazardsnotClassChecked();
      }

      this.physicalHazardInformation.physicalStateChecked = true;
      if (this.physicalHazardInformation.physicalStateChecked) {
        this.physicalHazardInformation.onPhysicalStateChecked();
      }
      this.physicalHazardInformation.combustibleDustsChecked = true;
      if (this.physicalHazardInformation.combustibleDustsChecked) {
        this.physicalHazardInformation.onCombustibleDustsChecked();
      }
      this.physicalHazardInformation.corrosiveToMetalsChecked = true;
      if (this.physicalHazardInformation.corrosiveToMetalsChecked) {
        this.physicalHazardInformation.onCorrosiveToMetalsChecked();
      }
      this.physicalHazardInformation.flammableAerosolsChecked = true;
      if (this.physicalHazardInformation.flammableAerosolsChecked) {
        this.physicalHazardInformation.onFlammableAerosolsChecked();
      }
      this.physicalHazardInformation.flammableGasesChecked = true;
      if (this.physicalHazardInformation.flammableGasesChecked) {
        this.physicalHazardInformation.onFlammableGasesChecked();
      }
      this.physicalHazardInformation.flammableLiquidsChecked = true;
      if (this.physicalHazardInformation.flammableLiquidsChecked) {
        this.physicalHazardInformation.onFlammableLiquidsChecked();
      }
      this.physicalHazardInformation.flammableSolidsChecked = true;
      if (this.physicalHazardInformation.flammableSolidsChecked) {
        this.physicalHazardInformation.onFlammableSolidsChecked();
      }
      this.physicalHazardInformation.gasesUnderPressureChecked = true;
      if (this.physicalHazardInformation.gasesUnderPressureChecked) {
        this.physicalHazardInformation.onGasesUnderPressureChecked();
      }
      this.physicalHazardInformation.oxidizingGasesChecked = true;
      if (this.physicalHazardInformation.oxidizingGasesChecked) {
        this.physicalHazardInformation.onOxidizingGasesChecked();
      }
      this.physicalHazardInformation.oxidizingLiquidsChecked = true;
      if (this.physicalHazardInformation.oxidizingLiquidsChecked) {
        this.physicalHazardInformation.onOxidizingLiquidsChecked();
      }
      this.physicalHazardInformation.oxidizingSolidsChecked = true;
      if (this.physicalHazardInformation.oxidizingSolidsChecked) {
        this.physicalHazardInformation.onOxidizingSolidsChecked();
      }
      this.physicalHazardInformation.organicPeroxidesChecked = true;
      if (this.physicalHazardInformation.organicPeroxidesChecked) {
        this.physicalHazardInformation.onOrganicPeroxidesChecked();
      }
      this.physicalHazardInformation.pyrophoricGasesChecked = true;
      if (this.physicalHazardInformation.pyrophoricGasesChecked) {
        this.physicalHazardInformation.onPyrophoricGasesChecked();
      }
      this.physicalHazardInformation.pyrophoricLiquidsChecked = true;
      if (this.physicalHazardInformation.pyrophoricLiquidsChecked) {
        this.physicalHazardInformation.onPyrophoricLiquidsChecked();
      }
      this.physicalHazardInformation.pyrophoricSolidsChecked = true;
      if (this.physicalHazardInformation.pyrophoricSolidsChecked) {
        this.physicalHazardInformation.onPyrophoricSolidsChecked();
      }
      this.physicalHazardInformation.selfHeatingSubstancesMixturesChecked = true;
      if (this.physicalHazardInformation.selfHeatingSubstancesMixturesChecked) {
        this.physicalHazardInformation.onSelfHeatingSubstancesMixturesChecked();
      }
      this.physicalHazardInformation.selfReactiveSubstancesChecked = true;
      if (this.physicalHazardInformation.selfReactiveSubstancesChecked) {
        this.physicalHazardInformation.onSelfReactiveSubstancesMixturesChecked();
      }
      this.physicalHazardInformation.simpleAsphyxiantsChecked = true;
      if (this.physicalHazardInformation.simpleAsphyxiantsChecked) {
        this.physicalHazardInformation.onSimpleAsphyxiantsChecked();
      }
      this.physicalHazardInformation.substancesMixturesWaterGasChecked = true;
      if (this.physicalHazardInformation.substancesMixturesWaterGasChecked) {
        this.physicalHazardInformation.onSubstancesMixturesWaterGasChecked();
      }
      this.physicalHazardInformation.physicalHazardsNotOtherwiseClassifiedChecked = true;
      if (this.physicalHazardInformation.physicalHazardsNotOtherwiseClassifiedChecked) {
        this.physicalHazardInformation.onPhysicalHazardsNotOtherwiseClassifiedChecked();
      }

      this.oneProductPR = 'true';
      this.checkOneProductPerRow = true;
      this.healthInformation.checkAllHealthHazard = true;
      this.physicalHazardInformation.checkAllPhysicalHazard = true;
      this.manufacturerInformation.checkAllManufacturerInfo = false;
      this.productChemicalInformation.checkAllProdChemical = false;
      this.locationTree.checklistSelection.clear();
      this.productInformation.dateAddedDisabled = true; // disable date
      this.productInformation.dateAddedChecked = false; // uncheck date
      this.oneRowPL = '';
      this.checkProductPropertyInfo = false;

      this.productInformation.sdsFileChecked = false;
      this.productInformation.productCodeChecked = false;
      this.productInformation.additionalSupplierChecked = false;

      this.manufacturerInformation.urlChecked = false;
      this.manufacturerInformation.sdsURLChecked = false;
      this.manufacturerInformation.contactLocationChecked = false;
      this.manufacturerInformation.contactDetailsChecked = false;
      this.manufacturerInformation.effectiveContactMethodChecked = false;

      this.productChemicalInformation.hmisRatingsChecked = false;
      this.productChemicalInformation.iarcMonographChecked = false;
      this.productChemicalInformation.transportHazardClassChecked = false;
      this.productChemicalInformation.nfpaRatingsChecked = false;
      this.productChemicalInformation.ACGIHCarcinogenicityNotationChecked = false;
    } else {
      this.productInformation.productNameChecked = false;
      this.productInformation.manufacturerNameChecked = false;
      this.productInformation.revisionDateChecked = false;
      this.productInformation.discontinuedChecked = false;
      this.productInformation.exemptWHMISChecked = false;
    }
  }


  constructor(
    private userService: UserService,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    private reportService: ReportService,
    private authService: AuthService,
    private changeDet: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.getAuthorityNames();
    this.oneProductPR = 'true';
    // default radio button checked on load
    // this.checkOneProductPerRow = true;
     // get userid for location tree (for site admins)
     this.sdsUserId = this.authService.decodedToken.userid;
     this.sdsUserIdNumber = +this.sdsUserId;
  }

  onSelectAuthority(selectedAuth: number) {
    if (selectedAuth !== null) {
      this.arrayAuth = selectedAuth;
      this.authorityLocation = this.arrayAuth;
    } else {
      this.authorityLocation = 0;
    }

  }

  getAuthorityNames() {
    this.userService.getAuthorityNames().subscribe(
      res => {
        // console.log(res);
        this.authorities = res;
      },
      error => {
        console.log('There was an error: ' + error);
      }
    );
  }

  openDiaglogGenerate(authority) {
    const dialogRef = this.dialog.open(GenerateComponent, {
      data: {
        authority: authority
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
    });
  }

  openDiaglogSchedule(authority) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      data: {
        authority: authority
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
    });
  }



  onAuthorityLocationChecked() {
    this.authorityLocation = '';
    if (this.authorityLocationChecked) {
      this.authorityLocation = 'AuthorityLocation';
    }
  }

  onMostRecentRequestDateChecked() {
    this.mostRecentRequestDate = '';
    if (this.mostRecentRequestDateChecked) {
      this.mostRecentRequestDate = 'MostRecentRequestDate';
    }
  }

  onSelectOnePerRow(event) {
    console.log(event);
    this.oneProductPR = '';
    if (event.source._checked && event.value === '4') {
      this.oneRowPL = '';
      this.oneProductPR = 'true';
    }
    this.productInformation.dateAddedChecked = false;
    this.productInformation.dateAdded = '';
    this.productInformation.dateAddedDisabled = true;
  }

  testestestest = false;
  onSelectRowPerLocation(event) {
    this.oneRowPL = '';
    if (event.source._checked && event.value === '5') {
      this.oneProductPR = '';
      this.oneRowPL = 'true';
      this.testestestest = true;
    }
    this.productInformation.dateAddedDisabled = false;
  }

  // selected;

  onSelectLocations(selected) {
    this.myList = selected;
    this.model.manufacturerId = this.myList;
  }


  disableLocationTree() {
    if (this.oneRowPL === 'true') {
      return true;
    } else {
      this.locationTree.checklistSelection.clear();
      return false;
    }
  }

  generateExcelReport() {
    const obj: ReportObj = {
      oneProductPerRow: '',
      oneRowPerLocation: '',
      ProductPropertyInfo: '',
      LocationId: []
    };
    this.loading = true;
    const params = new URLSearchParams();

    if (this.mostRecentRequestDate !== undefined && this.mostRecentRequestDate.length !== 0) {
      params.append('selection', this.mostRecentRequestDate);
    }

    this.productInformation.getCheckedValues().forEach((item) => {
      params.append('selection', item);
    });

    this.manufacturerInformation.getCheckedValues().forEach((item) => {
      params.append('selection', item);
    });

    this.healthInformation.getCheckedValues().forEach((item) => {
      params.append('selection', item);
    });

    this.physicalHazardInformation.getCheckedValues().forEach((item) => {
      params.append('selection', item);
    });

    this.productChemicalInformation.getCheckedValues().forEach((item) => {
      params.append('selection', item);
    });

       // super admin location tree/location ID
      if (this.authService.decodedToken.role === 'Super Admin') {
        obj.LocationId = [];
        for (const loc of this.locationTree.checklistSelection.selected) {
            obj.LocationId.push(loc.authorityUnitId);
        }
      }

      if (this.authService.decodedToken.role === 'Site Admin') {
        obj.LocationId = [];
        for (const loc of this.locationTree.checklistSelection.selected) {
          if (loc.userId === this.sdsUserIdNumber) {
            obj.LocationId.push(loc.authorityUnitId);
          }
        }
      }

    if (this.oneProductPR !== '') {
      obj.oneProductPerRow = this.oneProductPR;
    }
    if (this.oneRowPL !== '') {
      obj.oneRowPerLocation = this.oneRowPL;
    }
    if (this.ProductPropertyInfo !== '') {
      obj.ProductPropertyInfo = this.ProductPropertyInfo;
    }

    this.isLoading = true;
    this.reportService.generateReport(params, obj).subscribe(res => {
        this.locationsNotSelectedError = res.headers.get('locationsnotselected');
        this.selectionRequiredError = res.headers.get('selectionrequired');
        if (this.locationsNotSelectedError) {
          this.isLoading = false;
          this.loading = false;
          this.alertify.message(this.locationsNotSelectedError);
        } else if (this.selectionRequiredError) {
          this.isLoading = false;
          this.loading = false;
          this.alertify.message(this.selectionRequiredError);
        } else {
          if (res) {
            const link = document.createElement('a');
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
              window.navigator.msSaveOrOpenBlob(res.body, 'Product' + `.xlsx`);
              this.loading = false;
              this.alertify.message('Product report generation is complete');
          } else {
            link.href = window.URL.createObjectURL(res.body);
            link.download = 'Product';
            link.click();
            this.loading = false;
            this.alertify.message('Product report generation is complete');
          }
          }
        }
      },
      error => {
        this.alertify.error(
          'Product Report Generation failed, please try again!'
        );
        this.isLoading = false;
        this.loading = false;
      }
    );
  }

  generateButton(selectedBox) {
    this.selection = selectedBox;
    this.generateExcelReport();
  }
}

export interface ReportObj {
  oneProductPerRow: string;
  oneRowPerLocation: string;
  ProductPropertyInfo: string;
  LocationId: number[]
}

